module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201113_063.c78cf92d.jpg";